// extracted by mini-css-extract-plugin
export default {"btnpwd":"_2accc94c65"};